import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_time",
  "use": "icon-icon_time-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-icon_time\">\r\n  <defs>\r\n    <style>\r\n      #icon-icon_time .cls-1 {\r\n        fill: #b4bccc;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-icon_time_icon_date\" class=\"cls-1\" d=\"M14,14H0V1H3V0H4V1h6V0h1V1h3V14h0ZM1,13H13V5H1ZM13,4V2H11V3H10V2H4V3H3V2H1V4ZM9,11V10h2v1ZM6,11V10H8v1ZM3,11V10H5v1ZM9,8V7h2V8ZM6,8V7H8V8ZM3,8V7H5V8Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol